import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { setTheme } from "@store/uiSlice";
import { useDispatch, useSelector } from "react-redux";
export function HeaderComponent() {
    const dispatch = useDispatch();
    const theme = useSelector((state) => state.ui.theme);
    const lightIcon = _jsx("circle", { cx: "12", cy: "12", r: "5", fill: "currentColor" });
    const darkIcon = _jsx("path", { d: "M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z", fill: "currentColor" });
    const [icon, setIcon] = useState(darkIcon);
    function toggleTheme() {
        if (theme === 'dark') {
            setIcon(darkIcon);
            document.body.classList.add('dark');
        }
        else {
            setIcon(lightIcon);
            document.body.classList.remove('dark');
        }
    }
    function handleThemeToggle() {
        dispatch(setTheme(theme === 'light' ? 'dark' : 'light'));
    }
    useEffect(() => {
        toggleTheme();
    }, [theme]);
    useEffect(() => {
        toggleTheme();
    }, []);
    return (_jsx("div", { className: "header", children: _jsxs("button", { id: "toggle-theme", onClick: handleThemeToggle, children: [_jsx("svg", { id: "theme-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: icon }), "Theme"] }) }));
}
